export enum RegistrationPageSteps {
  choseDevice,
  deviceExists,
  createAccount
}
